/**
 * Global counter to scope the custom elements
 *
 * @type {number}
 */
var counter = Math.round(Math.random() * 100000);

/**
 * Allowed tag name chars
 *
 * @type {string}
 */
var chars = "-|\\.|[0-9]|[a-z]";

/**
 * Regular expression to check if a value is a valid tag name
 *
 * @type {RegExp}
 */
var tagRegExp = new RegExp("[a-z](".concat(chars, ")*-(").concat(chars, ")*"));

/**
 * Checks if the tag name is valid
 *
 * @param {string} tag
 * @returns {boolean}
 */
var isValid = function isValid(tag) {
  return tagRegExp.exec(tag) !== null;
};

/**
 * Checks if the tag is already registered
 *
 * @param {string} name
 * @param {CustomElementRegistry} registry
 * @returns {boolean}
 */
var isTagRegistered = function isTagRegistered(name, registry) {
  return !!registry.get(name);
};

/**
 * Given a tag name scopes it with a number suffix
 *
 * @param {string} tagName
 * @param {CustomElementRegistry} registry
 * @returns {string} scoped tag name
 */
var incrementTagName = function incrementTagName(tagName, registry) {
  var newTagName = "".concat(tagName, "-").concat(counter += 1);
  if (isTagRegistered(newTagName, registry)) {
    return incrementTagName(tagName, registry);
  }
  return newTagName;
};

/**
 * Creates a unique scoped tag name
 *
 * @exports
 * @param {string} tagName - tag name to scope
 * @param {CustomElementRegistry} registry
 * @returns {string} scoped tag name
 */
function createUniqueTag(tagName) {
  var registry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : customElements;
  if (!isValid(tagName)) {
    throw new Error('tagName is invalid');
  }
  return incrementTagName(tagName, registry);
}

export { createUniqueTag };
